import Axios from 'axios';

export const setupAxiosInterceptors = () => {
    Axios.interceptors.request.use(x => {
        const headers = {
            ...x.headers.common,
            ...x.headers[x.method],
            ...x.headers
        };

        ['common', 'get', 'post', 'head', 'put', 'patch', 'delete'].forEach(header => {
            delete headers[header]
        });

        const printable = `${new Date()} | Request: ${x.method.toUpperCase()} | ${x.url} | ${JSON.stringify(x.data)} | ${JSON.stringify(headers)}`;
        console.log(printable);
        return x;
    });

    Axios.interceptors.response.use(x => {
        const printable = `${new Date()} | Response: ${x.status} | ${JSON.stringify(x.data)}`;
        console.log(printable);
        return x;
    }, error => {
        handleAxiosError(error);
        return Promise.reject(error);
    });
};

const handleAxiosError = (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        console.log('JWT token expired or invalid, clearing localStorage');
        localStorage.clear();
        window.location.href = '/';
    }
};
